"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _propTypes2 = require("../propTypes");

var s = _interopRequireWildcard(require("./Cell.style"));

var Cell =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Cell, _PureComponent);

  function Cell() {
    (0, _classCallCheck2.default)(this, Cell);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Cell).apply(this, arguments));
  }

  (0, _createClass2.default)(Cell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$col = _this$props.col,
          render = _this$props$col.render,
          key = _this$props$col.key,
          cellStyle = _this$props$col.cellStyle,
          cellContentStyle = _this$props$col.cellContentStyle,
          index = _this$props.index,
          rowData = _this$props.rowData,
          rowHeight = _this$props.rowHeight,
          columns = _this$props.columns,
          indentLevel = _this$props.indentLevel,
          expandButton = _this$props.expandButton;
      var tdProps = {
        style: cellStyle,
        className: s.td,
        height: rowHeight
      };
      var cellValue = (0, _get.default)(rowData, key);
      var renderElement = render ? render(cellValue, rowData, index, columns) : cellValue;

      if (_react.default.isValidElement(renderElement) && renderElement.type === 'td') {
        var _renderElement$props = renderElement.props,
            colSpan = _renderElement$props.colSpan,
            rowSpan = _renderElement$props.rowSpan;
        if (colSpan === 0 || rowSpan === 0) return null;
        return _react.default.cloneElement(renderElement, (0, _objectSpread2.default)({}, renderElement.props, tdProps));
      }

      var indentText = _react.default.createElement("span", {
        style: {
          paddingLeft: "".concat(indentLevel * 22, "px")
        }
      });

      return _react.default.createElement("td", tdProps, _react.default.createElement("div", {
        className: s.tdContent,
        style: cellContentStyle
      }, indentText, expandButton, renderElement));
    }
  }]);
  return Cell;
}(_react.PureComponent);

Cell.propTypes = {
  col: _propTypes2.columnPropType.isRequired,
  rowData: _propTypes2.rowPropType.isRequired,
  index: _propTypes.default.number.isRequired,
  rowHeight: _propTypes.default.number,
  columns: _propTypes.default.arrayOf(_propTypes2.columnPropType).isRequired,
  indentLevel: _propTypes.default.number.isRequired,
  expandButton: _propTypes.default.element
};
var _default = Cell;
exports.default = _default;